/** Typed client for backend-owned SAC dashboard module URLs. */
import { api } from './api';

export type SacDashboardSlug = 'wow-dashboard' | 'smart-morning' | 'smart-finance';

export interface SacDashboardConfig {
  slug: SacDashboardSlug;
  title: string;
  url: string;
}

const BASE = '/api/v1/sac-dashboards';

export const sacDashboardApi = {
  async getConfig(slug: SacDashboardSlug): Promise<SacDashboardConfig> {
    const { data } = await api.get<SacDashboardConfig>(`${BASE}/${slug}`);
    return data;
  },
};
